<div class="modal" data-id="evp-modal" hidden>
  <div class="modal__backdrop" data-id="evp-backdrop"></div>

  <!-- autocomplete="off" plus the neutral field names below: the venue block
       looks like a postal address to Chrome, which then offers to save the
       venue as one of the operator's own addresses. -->
  <form class="modal__dialog modal__dialog--wide" data-id="evp-form-el" role="dialog" aria-modal="true"
        aria-labelledby="evp-form-title" novalidate autocomplete="off">
    <header class="modal__header">
      <h2 class="modal__title" id="evp-form-title" data-id="evp-title"><%= _lcs( 'Veranstaltung bearbeiten' ) %></h2>
      <button type="button" class="iconbtn modal__close" data-id="evp-close" aria-label="<%= _lcs( 'Schließen' ) %>">
        <i class="icon icon--x"></i>
      </button>
    </header>

    <div class="modal__body">
      <p class="modal__error" data-id="evp-error" hidden></p>

      <!-- Provenance + what saving means for the next import. -->
      <div class="evp-form__origin" data-id="evp-origin">
        <p class="evp-form__origin-line">
          <i class="icon icon--layers"></i>
          <span data-id="evp-origin-text">–</span>
        </p>
        <p class="evp-form__origin-note" data-id="evp-lock-note"></p>
        <button type="button" class="btn btn--ghost btn--sm evp-form__unlock" data-id="evp-unlock" hidden>
          <i class="icon icon--rotate-cw"></i> <%= _lcs( 'Wieder mit der Quelle synchronisieren' ) %>
        </button>
      </div>

      <!-- Recognised as a repeat of an event another feed delivered first. -->
      <div class="evp-form__duplicate" data-id="evp-duplicate" hidden>
        <p class="evp-form__origin-line">
          <i class="icon icon--layers"></i>
          <span><%= _lcs( 'Als Dublette erkannt' ) %></span>
        </p>
        <p class="evp-form__origin-note">
          <%= _lcs( 'Diese Veranstaltung wurde bereits über eine andere Quelle importiert und wird Gästen deshalb nicht angezeigt. Wenn es sich doch um eine eigenständige Veranstaltung handelt, lässt sich die Verknüpfung aufheben — sie wird dann sichtbar und künftig nicht mehr automatisch zugeordnet.' ) %>
        </p>
        <button type="button" class="btn btn--ghost btn--sm evp-form__unlock" data-id="evp-release">
          <i class="icon icon--check"></i> <%= _lcs( 'Keine Dublette — wieder anzeigen' ) %>
        </button>
      </div>

      <!-- ============================== Inhalt ============================= -->
      <h3 class="evp-form__legend"><%= _lcs( 'Inhalt' ) %></h3>

      <div class="field">
        <label class="field__label" for="evp-title"><%= _lcs( 'Titel' ) %></label>
        <div class="field__control">
          <span class="field__icon"><i class="icon icon--type"></i></span>
          <input class="field__input" id="evp-title" name="title" type="text" required maxlength="255"
                 autocomplete="off" data-msg-required="<%= _lcs( 'Bitte gib einen Titel ein.' ) %>" />
        </div>
      </div>

      <div class="evp-form__row">
        <div class="field">
          <label class="field__label" for="evp-category"><%= _lcs( 'Kategorie' ) %></label>
          <div class="field__control">
            <span class="field__icon"><i class="icon icon--tags"></i></span>
            <select class="field__input field__select" id="evp-category" name="category"></select>
          </div>
        </div>
        <div class="field">
          <label class="field__label" for="evp-status"><%= _lcs( 'Status' ) %></label>
          <div class="field__control">
            <span class="field__icon"><i class="icon icon--eye"></i></span>
            <select class="field__input field__select" id="evp-status" name="status">
              <option value="published"><%= _lcs( 'Veröffentlicht — in der Gäste-App sichtbar' ) %></option>
              <option value="draft"><%= _lcs( 'Entwurf — nicht sichtbar' ) %></option>
              <option value="cancelled"><%= _lcs( 'Abgesagt' ) %></option>
              <option value="postponed"><%= _lcs( 'Verschoben' ) %></option>
              <option value="archived"><%= _lcs( 'Archiviert — aus dem Feed entfernt' ) %></option>
            </select>
          </div>
        </div>
      </div>

      <div class="field">
        <label class="field__label" for="evp-subtitle"><%= _lcs( 'Untertitel' ) %></label>
        <div class="field__control">
          <input class="field__input" id="evp-subtitle" name="subtitle" type="text" maxlength="255" autocomplete="off" />
        </div>
      </div>

      <div class="field">
        <label class="field__label" for="evp-teaser"><%= _lcs( 'Kurztext' ) %></label>
        <div class="field__control field__control--textarea">
          <textarea class="field__input" id="evp-teaser" name="teaser" rows="2" maxlength="500"></textarea>
        </div>
        <p class="field__note"><%= _lcs( 'Erscheint auf der Karte in der Gäste-App.' ) %></p>
      </div>

      <div class="field">
        <label class="field__label" for="evp-description"><%= _lcs( 'Beschreibung' ) %></label>
        <div class="field__control field__control--textarea">
          <textarea class="field__input" id="evp-description" name="description" rows="5" maxlength="20000"></textarea>
        </div>
      </div>

      <!-- Read-only: the machine translations of the texts above, made by the
           import (core-api ContentTranslationService). Not editable here. -->
      <h3 class="evp-form__legend"><%= _lcs( 'Übersetzungen' ) %> <span class="evp-form__legend-note"><%= _lcs( 'automatisch' ) %></span></h3>
      <div class="evp-form__langs" data-id="evp-langs"></div>
      <dl class="evp-form__translation" data-id="evp-translation" hidden></dl>

      <!-- =============================== Ort =============================== -->
      <h3 class="evp-form__legend"><%= _lcs( 'Ort' ) %></h3>

      <div class="field">
        <label class="field__label" for="evp-locationname"><%= _lcs( 'Name des Ortes' ) %></label>
        <div class="field__control">
          <span class="field__icon"><i class="icon icon--map-pin"></i></span>
          <input class="field__input" id="evp-locationname" name="evp-venue" type="text" maxlength="160" autocomplete="off" />
        </div>
      </div>

      <div class="evp-form__row">
        <div class="field evp-form__grow">
          <label class="field__label" for="evp-street"><%= _lcs( 'Straße & Nr.' ) %></label>
          <div class="field__control">
            <input class="field__input" id="evp-street" name="evp-venue-line" type="text" maxlength="160" autocomplete="off" />
          </div>
        </div>
        <div class="field">
          <label class="field__label" for="evp-postalcode"><%= _lcs( 'PLZ' ) %></label>
          <div class="field__control">
            <input class="field__input" id="evp-postalcode" name="evp-venue-code" type="text" maxlength="16" autocomplete="off" />
          </div>
        </div>
        <div class="field evp-form__grow">
          <label class="field__label" for="evp-city"><%= _lcs( 'Ort' ) %></label>
          <div class="field__control">
            <input class="field__input" id="evp-city" name="evp-venue-place" type="text" maxlength="120" autocomplete="off" />
          </div>
        </div>
      </div>

      <!-- ============================== Links ============================== -->
      <h3 class="evp-form__legend"><%= _lcs( 'Links & Hervorhebung' ) %></h3>

      <div class="evp-form__row">
        <div class="field evp-form__grow">
          <label class="field__label" for="evp-ticketurl"><%= _lcs( 'Ticket-Link' ) %></label>
          <div class="field__control">
            <span class="field__icon"><i class="icon icon--ticket"></i></span>
            <input class="field__input" id="evp-ticketurl" name="ticketUrl" type="url" maxlength="500" placeholder="https://" />
          </div>
        </div>
        <div class="field evp-form__grow">
          <label class="field__label" for="evp-websiteurl"><%= _lcs( 'Website' ) %></label>
          <div class="field__control">
            <span class="field__icon"><i class="icon icon--compass"></i></span>
            <input class="field__input" id="evp-websiteurl" name="websiteUrl" type="url" maxlength="500" placeholder="https://" />
          </div>
        </div>
      </div>

      <label class="checkbox evp-form__toggle">
        <input type="checkbox" id="evp-featured" name="isFeatured" />
        <span class="checkbox__box"><i class="icon icon--check"></i></span>
        <%= _lcs( 'Als Empfehlung hervorheben' ) %>
      </label>

      <label class="checkbox evp-form__toggle">
        <input type="checkbox" id="evp-outdoor" name="isOutdoor" />
        <span class="checkbox__box"><i class="icon icon--check"></i></span>
        <%= _lcs( 'Findet draußen statt (wetterabhängig)' ) %>
      </label>

      <!-- Images and dates are the provider's; shown read-only so an operator
           can see what the guest sees without being able to edit what the next
           import owns. -->
      <h3 class="evp-form__legend"><%= _lcs( 'Bilder' ) %> <span class="evp-form__legend-note"><%= _lcs( 'aus der Quelle' ) %></span></h3>
      <div class="evp-form__images" data-id="evp-images"></div>

      <h3 class="evp-form__legend"><%= _lcs( 'Termine' ) %> <span class="evp-form__legend-note"><%= _lcs( 'aus der Quelle' ) %></span></h3>
      <div class="evp-form__dates" data-id="evp-dates"></div>
    </div>

    <footer class="modal__footer">
      <button type="button" class="btn btn--ghost btn--sm" data-id="evp-cancel"><%= _lcs( 'Abbrechen' ) %></button>
      <button type="submit" class="btn btn--primary btn--sm" data-id="evp-submit">
        <span data-id="evp-submit-label"><%= _lcs( 'Speichern' ) %></span>
      </button>
    </footer>
  </form>
</div>
